export var DEFAULT_LANG_LIST = [
    { shortKey: "en", translationKey: "common:langs.english" },
    { shortKey: "sv", translationKey: "common:langs.swedish" },
    { shortKey: "da", translationKey: "common:langs.danish" },
    { shortKey: "nb", translationKey: "common:langs.norwegian" },
    { shortKey: "sk", translationKey: "common:langs.slovakian" },
    { shortKey: "pl", translationKey: "common:langs.polish" },
    { shortKey: "fo", translationKey: "common:langs.faroese" },
    { shortKey: "nl", translationKey: "common:langs.dutch" },
    { shortKey: "es", translationKey: "common:langs.spanish" },
];
//# sourceMappingURL=languages.js.map